/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import PrimaryButton from '../../../shared/buttons/primary-button/primary-button';

import FormValidator from '../../../../utilities/formValidator';
import PasswordWithConfirm from '../../../shared/blocks/password-with-confirm/password-with-confirm';
import ConfirmationCodeInput from '../../../shared/inputs/confirmation-code-input/confirmation-code-input';
import GlobalError from '../../../shared/blocks/global-error/global-error';

const CreatePassword = ({
  userEmail,
  verify,
  resetPasswordCallback,
  timeoutCallback,
  isThereAnError,
}) => {
  const navigate = useNavigate();
  const formValidator = FormValidator();
  const [confirmationCode, setConfirmationCode] = useState(null);
  const [lengthFormError, setLengthFormError] = useState(null);
  const [matchFormError, setMatchFormError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const confirmCode = (code) => {
    setConfirmationCode(code);
  };

  useEffect(() => {
    if (verify) {
      confirmCode(verify);
    }
  }, [verify]);

  const submit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const newPassword = document.getElementById('newPassword').value;
    const confirmPassword = document.getElementById('confirmPassword').value;
    try {
      formValidator.formValidate('reset_password');
      if (newPassword === confirmPassword) {
        try {
          if (confirmationCode.includes(' ')) {
            // eslint-disable-next-line no-throw-literal
            throw { name: 'EmptyErrorCode' };
          } else {
            await Auth.forgotPasswordSubmit(userEmail, confirmationCode, newPassword);
            sessionStorage.setItem('resetPassword', 'true');
            navigate('/login');
          }
        } catch (error) {
          formValidator.errorHandling(error);
          if (error.name.includes('LimitExceeded')) {
            timeoutCallback();
          }
          if (error.message.includes('Password')) {
            setLengthFormError(false);
          }
        }
        setIsLoading(false);
      } else {
        const error = { name: 'PasswordMismatchException', message: 'Passwords do not match' };
        setMatchFormError(false);
        formValidator.errorHandling(error);
      }
    } catch (error) {
      // handle errors
      formValidator.errorHandling(error);
      setLengthFormError(false);
    }
  };

  return (
    <div className="bg-white accounts-modal-content create-password mw-s">
      <CodeCapture
        userEmail={userEmail}
        defaultCode={confirmationCode}
        resetPasswordCallback={resetPasswordCallback}
        setConfirmationCode={setConfirmationCode}
        setCodeCallback={confirmCode}
        isThereAnError={isThereAnError}
      />
      <div className="c-light-midnight m-b-16">
        <form className="d-flex-column m-b-s" id="reset_password" onSubmit={submit}>
          <div className="m-b-16">
            <PasswordWithConfirm
              lengthPasswordError={lengthFormError}
              matchPasswordError={matchFormError}
              inputId="newPassword"
              inputName="newPassword"
              label="Password"
              confirmInputId="confirmPassword"
              confirmInputName="confirmPassword"
              confirmLabel="Confirm Password"
              passwordException="jsNewPasswordExceptionExtra"
              confirmPasswordException="jsConfirmPasswordExceptionExtra"
            />
          </div>
          <div className="m-b-s">
            <PrimaryButton
              onClick={submit}
              isLoading={isLoading}
              title="Reset Password"
              buttonType="submit"
            />
          </div>
        </form>
        <p className="ff-graphik-medium fw-normal fs-p3 need-help">Need more help?</p>
        <div className="ff-graphik fs-p3 lh-24 customer-care-link m-t-4">
          If you're still having difficulty logging into your account, please call our customer service representatives at
          <a className="c-light-midnight td-underline td-none m-l-5" href="tel:18888488456">888-848-8456</a>
        </div>
      </div>
      <p className="ff-graphik fw-normal fs-p3">
        <span className="fw-normal ff-graphik-medium">Questions?</span>
        {' '}
        Visit our
        {' '}
        <a className="ff-graphik fw-normal td-none td-underline c-purple-medium fs-p3" href="https://purple.com/support" rel="noreferrer" target="_blank">FAQs</a>
      </p>
    </div>
  );
};

export default CreatePassword;

const CodeCapture = ({
  userEmail,
  defaultCode,
  resetPasswordCallback,
  setConfirmationCode,
  isThereAnError,
}) => {
  const [resentEmail, setResentEmail] = useState(false);
  const [email, setEmail] = useState('');

  useEffect(() => {
    setEmail(userEmail);
  }, [userEmail]);

  const resendEmail = (e) => {
    e.preventDefault();
    setResentEmail(true);
    setEmail(userEmail);
    resetPasswordCallback(e, userEmail);
  };

  return (
    <div>
      <div className="m-b-s">
        <h2 className="ff-wallop c-purple-primary fs-h4 m-b-s">Reset Your Password</h2>
      </div>
      <GlobalError>
        <p className="c-utility-red fs-p2">Max reset password attempts met. Please wait 24-48 hours to reset again.</p>
      </GlobalError>
      {!isThereAnError && (
        <div className="bg-light-purple-4 success-message">
          {resentEmail && (
            <p className="c-purple-primary fs-16 ff-graphik">
              We have sent another verification code to
              <span className="fw-medium m-l-5">{email}</span>
              . It may take a few minutes
            </p>
          )}
          {!resentEmail && (
            <p className="c-purple-primary fs-16 ff-graphik">
              Verification code emailed to
              <span className="fw-medium m-l-5">{email}</span>
              .
            </p>
          )}
        </div>
      )}
      <form className="m-b-xs ta-center">
        <label htmlFor="one-time-code" className="fs-p2 ff-graphik m-b-16">Please enter your verification code below to reset your password.</label>
        <div className="form-input m-b-16 code-input">
          <ConfirmationCodeInput defaultValue={defaultCode} length={6} placeholder=" " onChange={setConfirmationCode} autoFocus />
        </div>
      </form>
      <div className="m-b-sm">
        <p className="ff-graphik c-light-midnight fs-p2 fw-normal ta-center">
          Didn't receive an email?
          <button className="m-l-5 link ff-graphik-medium fw-normal accent c-purple-medium td-underline fs-p2" onClick={resendEmail} type="button">Resend</button>
        </p>
      </div>
    </div>
  );
};
